import { render, staticRenderFns } from "./swipe.vue?vue&type=template&id=48606a96"
import script from "./swipe.vue?vue&type=script&lang=js"
export * from "./swipe.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports